export const companyProfileKeys = {
	all: ['companyProfile'],
	detail: () => ['companyProfile', 'detail'],
};

export const companyProfileMutationKeys = {
	save: ['companyProfile', 'save'],
};
